import type { Prestation, PrestationOrCategoryPrice } from '@wecasa/common/src/types/commons';
import colors from '@wecasa/common/src/utils/colors';
import { formatPrice } from '@wecasa/common/src/utils/formatting';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';

import { PrestationsListElement } from '../../../common/common';

type PrestationItemProps = {
  prestation?: Prestation;
  price?: PrestationOrCategoryPrice;
};

const PrestationItem = ({ prestation, price }: PrestationItemProps) => (
  <PrestationsListElement>
    <Text>{`• ${prestation?.title || '?'}`}</Text>
    {price && <Text.SM color={colors.ink50}>{formatPrice(price.standard)}</Text.SM>}
  </PrestationsListElement>
);

export default PrestationItem;
